module.exports = __webpack_public_path__ + "static/media/Overview.c8c09ec1.svg";